import { atom, useRecoilState } from 'recoil'
import { IProjectRole } from './projectRoles.types'

interface IProjectsAtomState {
  items: IProjectRole[]
  nextPage: string | null | undefined
  totalCount: number
}

export const projectRolesAtom = atom<IProjectsAtomState>({
  key: 'projectRoles',
  default: {
    items: [],
    totalCount: 0,
    nextPage: undefined,
  },
})
const useProjectRolesState = () => useRecoilState(projectRolesAtom)
export default useProjectRolesState
